// NATIVE 
import React from 'react';


// INSTALLED 
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { Avatar, Card, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select, Toolbar, Typography } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { ClearIcon } from '@mui/x-date-pickers';
import { hasPemissions } from '../../commons/utils';
import { useDispatch } from 'react-redux';
import { getSucursalesControlTiemposStore } from '../../store/control_tiempos';


// CUSTOM 


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.secondary.contrastText,
        fontSize: 15,
        fontWeight: 700
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontWeight: 500,
        color: '#2e263de6'
    },
}));
    

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));




export const ControlTiempos = () => {


    // USE DISPATCH 
    const dispatch = useDispatch();

    // USE STATE 
    const [alert_snack, setAlertSnack] = React.useState(false);

    const [message_alert_snack, setMessageAlertSnack] = React.useState('');
    const [type_alert_snack, setTypeAlertSnack] = React.useState('success');

    const [filter, setFilter] = React.useState('');


    const searchByFilter = async(event:any) => {
    
    
    
                                                  // permission_slug  // slug in childrens  // permission
        const havePermissions = await hasPemissions('modulo.manager', 'modulo.cliente',   'view');
        
        
        if( !havePermissions ){
    
          setAlertSnack(true);
    
          await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');
    
          setTypeAlertSnack('error')
    
          return false;
    
                                                                        
            
        }
    
    
        const param = event.target.value;
    
        if (param == '') {
            return false;
        }
        
        if ( param != '' ) {
             setFilter(param);
        }
    
        let parametroSearch = 1;
    
        if  (param == 'activos') {
            parametroSearch = 1;
        }
    
        if  (param == 'vencidos') {
             parametroSearch = 2;
        }
    
        if  (param == 'inactivos') {
             parametroSearch = 0;
        }
    
        
    
    
        const response =  await dispatch( getSucursalesControlTiemposStore(parametroSearch) );
        
        
        if ( !response.ok && response.statusCode == 403 || response.code && response.code == 403) {
    
          setAlertSnack(true);
    
          await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');
    
          setTypeAlertSnack('error')
    
          return false;
    
        } 
        
         
    }



    const getDataCustomers = async() => {
      
          
                                                   // permission_slug  // slug in childrens  // permission
          const havePermissions = await hasPemissions('modulo.manager', 'modulo.cliente',   'view');
          
          
              if( !havePermissions ){
          
                setAlertSnack(true);
      
                await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');
      
                setTypeAlertSnack('error')
          
                return false;
          
                                                                              
                  
              }
      
          
        //   const response =  await dispatch( getCustomersStore() );
      
        //   setFilter('');
        //   if ( !response.ok && response.statusCode == 403 || response.code && response.code == 403) {
      
        //     setAlertSnack(true);
      
        //     await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');
      
        //     setTypeAlertSnack('error')
      
        //     return false;
      
        //   }
      
        
    }


  return (
    <>
        ControlTiempos


        <Card
            sx={{
            display: 'flex',
            alignItems: 'center',
            p: 3,
            borderRadius: 2,
            boxShadow: 3,
            bgcolor: 'background.paper',
            }}
        >


        <Toolbar>
        
          <FormControl sx={{ m: 1, minWidth: 120, width: '40%' }}>
            <InputLabel id="demo-simple-select-helper-label">Filtro por estado</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={filter}
              
              label="Filtro por estado"
              onChange={ (event) => searchByFilter(event) }
              endAdornment={
                filter.length > 0 && (
                  <InputAdornment sx={{ marginRight: "10px" }} position="end">
                    <IconButton
                      onClick={getDataCustomers}
                    >
                      <ClearIcon></ClearIcon>
                    </IconButton>
                  </InputAdornment>
                )
              }
            >
              <MenuItem value="">
                <em>Selecione un filtro</em>
              </MenuItem>
              <MenuItem value={'activos'}>Activos</MenuItem>
              <MenuItem value={'vencidos'}>Vencidos</MenuItem>
              <MenuItem value={'inactivos'}>Inactivos</MenuItem>
            </Select>
          </FormControl>

        </Toolbar>

        </Card>


       
    <Grid container spacing={1} sx={{marginTop: 10, border: '1px solid rgba(0,0,0,.1)' }}>
       
        <Grid xs={12} sx={{ marginTop: 5, marginLeft: 5 }}>
           <Typography sx={{ color: '#34466', fontWeight: 500, textShadow: '1px 1px 3px white' }}> <span style={{ color: '#192a56', fontWeight: 700 }}>AAAAAAA</span> <span>(2)</span></Typography>  
        </Grid>
        <Grid item xs={1.3} sx={{ margin: 0, padding: 0 }}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2, marginTop: 0,  padding: 0 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2, marginTop: 0 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2, marginTop: 0 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2, marginTop: 0 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2, marginTop: 0 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2, marginTop: 0 }}
            />
        </Grid>
    </Grid>





    <Grid container spacing={1} sx={{marginTop: 2, border: '1px solid rgba(0,0,0,.1)' }}>
        <Grid xs={12} sx={{ marginTop: 5, marginLeft: 5 }}>
           <Typography sx={{ color: '#34466', fontWeight: 500, textShadow: '1px 1px 3px white' }}> <span style={{ color: '#192a56', fontWeight: 700 }}>BBBBBBB</span> <span>(2)</span></Typography>  
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2 }}
            />
        </Grid>
        <Grid item xs={1.3}>
           <Avatar
                alt="Remy Sharp"
                src="https://mui.com/static/images/avatar/1.jpg"
                sx={{ width: 100, height: 100, margin: 2 }}
            />
        </Grid>
    </Grid>

    
        
        
    </>
  )
}
